const tableHeaders = [
  {
    label: 'file-title',
    key: 'assetTitle',
    sortable: false,
  },
  {
    label: 'file-name',
    key: 'originalFileName',
    sortable: false,
  },
  {
    label: 'last-updated',
    key: 'updatedAt',
    sortable: false,
    filter: 'date',
  },
  {
    label: 'replace-file',
    key: 'replace',
    sortable: false,
  },
];

export default () => tableHeaders;
